import { isPositiveNumber, reduce } from "et3-type-guards";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UserSearchForm from "../../../components/user-pages/UserSearchForm";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserStore from "../../../stores/user-store";
import getUserLoginStore from "../../../stores/user-store/login-store";
import UserLoginData from "./user-login-data";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const UserLogin = withLiteObserverAndTheme(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const userID = getUserStore().userIdInput.get();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_LOGIN", "USER_LOGIN");
    getUserLoginStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("MONITOR_USER_LOGIN")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserSearchForm
        withPlatform={false}
        withLimit={true}
        disabled={!isPositiveNumber(userID)}
        onClickAction={async () => {
          await getUserLoginStore().getUserLogin();
          navigate({
            pathname: window.location.pathname,
            search: `?id=${getUserStore().userIdInput.get()}`
          });
        }}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserLoginData />
    </ET3PageDiv>
  );
});
export default UserLogin;
